/**
 * 실패 → 화면 경로. 재시도로 풀리지 않는 실패는 복구 흐름으로 보낸다 — 401 은 재로그인,
 * 403 은 결제·권한 안내. 일반 오류 슬롯("다시 시도")만 남기면 같은 응답이 반복될 뿐이다.
 */
import { isQuestionCardAiHttpError } from './questionCardAiHttpError';
import { errorCodeOf } from './questionCardAiOutcome';

export type QuestionCardAiRecovery = 'auth_expired' | 'plan_denied';

/** 실패를 어디에 보이나 — 액션 스펙의 기본값(slot | alert)보다 취소·복구가 앞선다. */
export type QuestionCardAiFailureRoute =
  | 'cancelled'
  | QuestionCardAiRecovery
  | 'slot'
  | 'alert';

const RECOVERY_BY_STATUS = new Map<number, QuestionCardAiRecovery>([
  [401, 'auth_expired'],
  [403, 'plan_denied'],
]);

export const resolveRecovery = (
  error: unknown,
): QuestionCardAiRecovery | null =>
  (isQuestionCardAiHttpError(error) && RECOVERY_BY_STATUS.get(error.status)) ||
  null;

/** 우선순위: 취소 → 복구 → 스펙의 실패 표시 방식. */
export const resolveFailureRoute = (
  error: unknown,
  fallback: 'slot' | 'alert',
): { code: string; route: QuestionCardAiFailureRoute } => {
  const code = errorCodeOf(error);
  if (code === 'ABORTED') return { code, route: 'cancelled' };
  return { code, route: resolveRecovery(error) ?? fallback };
};

/**
 * hard navigation — router.push 로는 만료 토큰 상태의 react-query 캐시와 메모리 상태가
 * 남아 재로그인 후에도 낡은 권한 판단이 이어질 수 있다(채팅과 같은 이유).
 */
export const redirectToLoginAndReturn = () => {
  if (typeof window === 'undefined') return;
  const callback = `${window.location.pathname}${window.location.search}`;
  window.location.assign(`/login?callbackUrl=${encodeURIComponent(callback)}`);
};
